import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { cpOrderCancellationThunks } from 'state/secondaryMarket/cpOrder/cancellation/cancellations.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

import { cpOrderCancelApiConnector } from '../../../apiConnector/secondary-market/cp-order/cancel';
import { cpOrderCancellationActions } from '../../../state/secondaryMarket/cpOrder/cancellation/cancellations.actions';

export interface CancelOrderApi {
  cancelOrder(orderId: string): Observable<unknown>;
}

export function cancelOrderEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_CANCELLATION_REQUESTED'),
      mergeMap(({ orderId }) => {
        return cpOrderCancelApiConnector(httpClient)
          .cancel(orderId)
          .pipe(
            map(response => cpOrderCancellationActions.secondaryMarketCancelReceived(orderId, response)),
            catchError((error: HttpError) => {
              frontLogger.error('An error occurred inside orderCancellationRequestedEpic {@FrontError}', error);
              return of(cpOrderCancellationThunks.orderCancellationErrorsThunk(orderId, error));
            }),
          );
      }),
    );
}
